<template>
    <div class="jump-box" v-if="_jumpData.isShow">
        <!-- jumpType = 2 全屏弹框 -->
        <div v-if="_jumpData.jumpType == 2" class="jump2-view">
            <div @click="_jumpData.isShow = false; isVideoPic3 = true" class="jump-close"></div>
            <!-- targetType = 1 文章 -->
            <div v-if="_jumpData.targetType == 1" class="target-box target1-box"> 
                <iframe id="article-3-1" :src="_jumpData.articleUrl" frameborder="0"></iframe>
            </div>

            <!-- targetType = 2 图片 -->
            <div v-if="_jumpData.targetType == 2" class="target-box target2-box"> 
                <div class="targ-scroll">
                    <img :src="_jumpData.imageUrl" alt="">
                </div>
            </div>

            <!-- targetType = 3 视频 -->
            <div class="target-box target3-box">
                <div class="video-box">
                    <img v-if="isVideoPic3" @click="videoPlayFun()" class="video-play" src="../../assets/playIco.png" alt="">
                    <div v-if="isVideoPic3" class="video-pic">
                        <img :src="_jumpData.imageUrl" alt="">
                    </div>
                    <video id="video-3-3" :src="_jumpData.videoUrl" controls="controls">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
            </div>
        </div>

        <!-- jumpType = 3 弹框内链 -->
        <div v-if="_jumpData.jumpType == 3" class="jump3-view">  
            <div @click="_jumpData.isShow = false; isVideoPic3 = true" class="jump-close"></div>
            <!-- targetType = 1 文章 -->
            <div v-if="_jumpData.targetType == 1" class="target-box target1-box"> 
                <iframe id="article-3-1" :src="_jumpData.articleUrl" frameborder="0"></iframe>
            </div>

            <!-- targetType = 2 图片 -->
            <div v-if="_jumpData.targetType == 2" class="target-box target2-box"> 
                <div class="targ-scroll">
                    <img :src="_jumpData.imageUrl" alt="">
                </div>
            </div>

            <!-- targetType = 3 视频 -->
            <div v-if="_jumpData.targetType == 3" class="target-box target3-box"> 
                <div class="video-box">
                    <img v-if="isVideoPic3" @click="videoPlayFun()" class="video-play" src="../../assets/playIco.png" alt="">
                    <div v-if="isVideoPic3" class="video-pic">
                        <img :src="_jumpData.imageUrl" alt="">
                    </div>
                    <video id="video-3-3" :src="_jumpData.videoUrl" controls="controls">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        _jumpData: {
            type: Object,
            default: {}
        }
    },
    data () {
        return {
            isVideoPic3: true,
        }
    },
    created () {
        
    },
    methods: {
        videoPlayFun(){
            this.isVideoPic3 = false;
            let video = document.getElementById("video-3-3");
            video.play();
        },
    },
}
</script>

<style lang="less" src="../../stylesNewUI/pc.less"></style>
<style lang="less">
.jump-box{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 980;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .8);

    .jump2-view{
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000;
        .jump-close{
            position: absolute;
            top: 40px;
            right: 40px;
            width: 60px;
            height: 60px;
            background: url(../../assets/closePC.png) no-repeat center;
            background-size: 100% 100%;
            cursor: pointer;
        }
        .target-box{
            width: 100%;
            height: 100%;
        }
        .target1-box{
            width: 100%;
            height: 100%;
            iframe{
                width: 100%;
                height: 100%;
            }
        }
        .target2-box{
            padding: 15px;
            .targ-scroll{
                overflow-x: hidden;
                overflow-y: scroll;
                width: 100%;
                height: 100%;
                img{
                    margin: 0 auto;
                    width: auto;
                    max-width: 100%;
                    height: auto;
                }
            }
        }
        .target3-box{
            display: flex;
            justify-content: center;
            align-items: center;
            .video-box{
                position: relative;
                width: 800px;
                height: 700px;
                .video-play{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -30px;
                    margin-left: -30px;
                    z-index: 88;
                    width: 60px;
                    height: 60px;
                    cursor: pointer;
                }
                .video-pic{
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 80;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    background-color: #000;
                    img{
                        width: auto;
                        height: 100%;
                    }
                }
                video{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .jump3-view{ 
        position: relative;
        width: 800px;
        height: 700px;
        .jump-close{
            position: absolute;
            top: -80px;
            right: -80px;
            width: 60px;
            height: 60px;
            background: url(../../assets/closePC.png) no-repeat center;
            background-size: 100% 100%;
            cursor: pointer;
        }
        .target-box{
            overflow: hidden;
            width: 100%;
            height: 100%;
            border-radius: 15px;
        }
        .target2-box{
            padding: 15px;
            background-color: #ffffff;
            .targ-scroll{
                width: 100%;
                height: 100%;
                overflow-x: hidden;
                overflow-y: scroll;
                img{
                    width: 100%;
                    height: auto;
                }
            }
        }
        .target3-box{
            border-radius: 0;
            background-color: #000;
            .video-box{
                position: relative;
                width: 100%;
                height: 100%;
                .video-play{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -30px;
                    margin-left: -30px;
                    z-index: 88;
                    width: 60px;
                    height: 60px;
                    cursor: pointer;
                }
                .video-pic{
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 80;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    background-color: #000;
                    img{
                        width: auto;
                        height: 100%;
                    }
                }
                video{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
#article-3-1{
    width: 100%;
    height: 100%;
}
</style>
